import { useCallback } from "react";
import { useMutation, useQuery } from "@apollo/client";

import { CompanyBenefitsForm } from "./Form";

import { handleMutationError } from "@hire/errors";
import {
  CompanyBenefitsDocument,
  CompanyInput,
  UpdateCompanyBenefitsDocument,
} from "@hire/schema";
import { CardContainer } from "@hire/components/containers/CardContainer";
import { Text } from "@otta/design";
import { ReloadableError } from "@hire/components/ReloadableError";
import { Loading } from "@otta/shared-components";

export const CompanyBenefits = () => {
  const { data, loading, refetch } = useQuery(CompanyBenefitsDocument);
  const [update] = useMutation(UpdateCompanyBenefitsDocument, {
    onError: handleMutationError,
  });

  const handleSave = useCallback(
    async (input: CompanyInput) => {
      if (!data?.currentUser?.currentCompany?.id) {
        return;
      }
      await update({
        variables: {
          id: data?.currentUser?.currentCompany?.id,
          input,
        },
      });
    },
    [data, update]
  );

  if (loading) {
    return <Loading />;
  }

  if (!data?.currentUser?.currentCompany) {
    return <ReloadableError action={refetch} />;
  }

  return (
    <>
      <Text bold size={2}>
        Employee benefits
      </Text>
      <CardContainer>
        <CompanyBenefitsForm
          data={data.currentUser?.currentCompany}
          handleSave={handleSave}
        />
      </CardContainer>
    </>
  );
};
